<template >
    <div
        v-if="
      inputModel  && Object.keys(inputModel).length > 0
    "
        class="row"
    >

      <div
          v-for="(currency, index_c) in inputObj.templates.currency"
          class="col col-sm-12 col-md-auto"
      >
        <h5>
          {{currency.title}}
        </h5>

        <table
          class="table"
        >
          <tr
              v-for="(type, index_t) in inputObj.templates.type"
          >
            <template
              v-if="getDisplayStatus(this.inputModel[currency.ident], this.inputModel[currency.ident][index_t].condition)"
            >
              <td>
                {{type.title}}
              </td>
              <td>

                <div
                    class="input-group"
                >
                  <input
                      v-model="this.inputModel[currency.ident][index_t].value"
                      type="number"
                      min="0"
                      class="form-control form-control-sm text-end"
                  />
                  <span class="input-group-text">{{currency.title}}</span>
                </div>
              </td>

            </template>
            <template v-else>
              <td>
                 &nbsp;
              </td>

            </template>
          </tr>
        </table>
      </div>
    </div>

  <!--
     <display-debug>
       <template #debugView>inputModel {{inputModel}}</templa  <!--
      <template #debugView>inputObj {{inputObj.templates}}</template>

    </display-debug>
    -->
</template>

<script>

export default {
  name: "PriceInput2",
  components: {
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": {
      type: [Object],
      required: false,
      default: null,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {},
    }
  },
  created() {
    this.inputModel = {};
    if(
        this.inputObj.templates.currency
    ) {
      for(const key in this.inputObj.templates.currency) {
        const types = {}
        for(const t in this.inputObj.templates.type) {
          types[t] = {
            condition: this.inputObj.templates.type[t].condition,
            isDisplay: true,
            value: null

          }; //null
        }
        this.inputModel[this.inputObj.templates.currency[key].ident] = types;
      }
    }
  },
  mounted() {
    if(
        this.inputObj.val
    ) {
      for(const key in this.inputObj.templates.currency) {

        for(const t in this.inputObj.templates.type) {
          if(
              typeof this.inputObj.val[this.inputObj.templates.currency[key].ident] != "undefined"
              && typeof this.inputObj.val[this.inputObj.templates.currency[key].ident][t] != "undefined"
          ) {
            this.inputModel[this.inputObj.templates.currency[key].ident][t].value = this.inputObj.val[this.inputObj.templates.currency[key].ident][t].value;
          }
        }
      }
    }
  },
  methods: {
    getDisplayStatus(item, condition) {
      let status = true
      if(typeof condition != "undefined" && condition) {
        for(const index_c in condition) {
          if(
              item[condition[index_c]].value == null
              || item[condition[index_c]].value <= 0
          ) {
            status = false;
          }
        }
      }
      return status
    }
  },
  watch: {
    inputObj: {
      handler() {
        if(this.inputObj.val){
          for (const c in this.inputModel){
            for (const t in this.inputModel[c]){
              for (const i in this.inputModel[c][t]){
                if(
                    this.inputObj.val
                    && typeof this.inputObj.val[c] != "undefined"
                    && typeof this.inputObj.val[c][t] != "undefined"
                    && typeof this.inputObj.val[c][t][i] != "undefined"
                ) {
                  this.inputModel[c][t][i] = this.inputObj.val[c][t][i];
                }
              }
            }
          }
        }
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    }
  },
};
</script>